import React from 'react';
import { Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Input } from '@/components/ui/input';
import type { TramiteTareaItem } from '../types';

interface TareaChecklistItemProps {
  tarea: TramiteTareaItem;
  onToggle: (tarea: TramiteTareaItem, completada: boolean) => void;
  onRenombrar: (tarea: TramiteTareaItem, nombre: string) => void;
  onEliminar: (tarea: TramiteTareaItem) => void;
  disabled?: boolean;
}

export const TareaChecklistItem: React.FC<TareaChecklistItemProps> = ({
  tarea,
  onToggle,
  onRenombrar,
  onEliminar,
  disabled = false,
}) => {
  return (
    <li className="flex items-center gap-2 rounded-lg border p-2">
      <Checkbox
        checked={tarea.completada}
        onCheckedChange={(checked) => onToggle(tarea, checked === true)}
        disabled={disabled}
        aria-label={`Marcar "${tarea.nombre}" como ${tarea.completada ? 'pendiente' : 'completada'}`}
      />
      <Input
        key={tarea.id}
        defaultValue={tarea.nombre}
        aria-label={`Editar nombre de ${tarea.nombre}`}
        className={`h-8 flex-1 ${tarea.completada ? 'text-muted-foreground line-through' : ''}`}
        maxLength={255}
        disabled={disabled}
        onBlur={(event) => {
          const nombre = event.target.value.trim();
          if (!nombre) {
            event.target.value = tarea.nombre;
            return;
          }
          if (nombre !== tarea.nombre) {
            onRenombrar(tarea, nombre);
          }
        }}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            event.currentTarget.blur();
          }
        }}
      />
      <Button
        size="icon"
        variant="ghost"
        title="Eliminar tarea"
        className="text-destructive hover:bg-destructive/10 hover:text-destructive"
        onClick={() => onEliminar(tarea)}
        disabled={disabled}
      >
        <Trash2 className="h-4 w-4" />
      </Button>
    </li>
  );
};

export default TareaChecklistItem;
